module.exports = __webpack_public_path__ + "img/20200328134847807.6eec454c.png";